import React, { Component } from "react";

class Footer extends Component {
    constructor(props){
        super(props)
        this.handleFeedback = this.handleFeedback.bind(this)
    }

    handleFeedback(){
      window.open('mailto:'+"oict-bi@un.org?subject=Feedback on the site&body=Detailed suggestions:")
  }

    render(){
        return (
            <footer className="w-100 row pr-0 mx-0">
              <div className="col-6">
                <div className="media footer-media pl-5 py-5">
                  <img className="footer-logo" src="http://pngimg.com/uploads/un/un_PNG15.png"/>
                  <div className="media-body">
                    <a href="https://unite.un.org">
                      <h5 className="footer-title mt-0 px-3 font-weight-bold text-secondary pt-0">
                        Office of Information <br />
                        and Communications Technology
                      </h5>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <ul className="list-inline pt-5 w-100 text-right">
                  {/* <li className="list-inline-item pr-3 small footer-link"><a href="/MasterDataSearch">Master Data</a></li> */}
                  <li className="list-inline-item pr-3 small footer-link"><a onClick={this.handleFeedback} href="#">Feedback</a></li>
                  <li className="list-inline-item pr-3 small footer-link"><a target="_blank" href="https://www.un.org/en/sections/about-un/frequently-asked-questions/">FAQs</a></li>
                  <li className="list-inline-item pr-3 small footer-link"><a target="_blank" href="https://www.un.org/en/contact-us/">Contact</a></li>
                  <li className="list-inline-item pr-3 small footer-link"><a target="_blank" href="https://www.un.org/en/sections/about-website/copyright/">Copyright</a></li>
                  <li className="list-inline-item pr-3 small footer-link"><a target="_blank" href="https://www.un.org/en/sections/about-website/terms-use/">Terms of Use</a></li>
                  <li className="list-inline-item pr-3 small footer-link"><a target="_blank" href="https://www.un.org/en/sections/about-website/privacy-notice/">Privacy Notice</a></li>
                </ul>
                <p className="text-muted pr-3 pt-0 w-100 small text-right user-select-none footer-disclaimer">&copy; 2022 United Nations OICT PSGD. All right reserved.</p>
              </div>
            </footer>
        )
    }
};


export default Footer;